import { usersApi } from '@/website/api/users'
import { BlockModule } from '@/website/blocks/common'
import { Spinner } from '@/components/core/spinners'
import errorMessages from '@/error-messages'
import { defineComponent, ref } from 'vue'

new BlockModule({
    selector: '.block-registration-verification',
    vueComponent: defineComponent({
        components: {
            Spinner,
        },
        setup() {
            const isVerifying = ref(true)
            const errorMessage = ref(errorMessages.UNEXPECTED_ERROR)

            const url = new URL(window.location.href)
            const emailAddress = url.searchParams.get('email')
            const otp = url.searchParams.get('otp')

            if (!otp || !emailAddress) {
                isVerifying.value = false
            }

            const verify = async () => {
                if (!otp || !emailAddress) return

                isVerifying.value = true
                const [results, error] = await usersApi.verifyRegistration(emailAddress, otp)

                if (results) {
                    window.location.assign(results.redirectUrl)
                }

                if (error) {
                    errorMessage.value = errorMessages.UNEXPECTED_ERROR
                }

                isVerifying.value = false
            }

            verify()

            return {
                isVerifying,
                errorMessage,
            }
        },
    }),
})
